import { createSlice } from '@reduxjs/toolkit';

export const STEP = {
  LOCATION: 'Location',
  PRODUCT_CARDS: 'Huurmiddel',
  PRODUCT_CONFIG: 'Configuratie',
  RENTAL_FORM: 'Client',
  DELIVERY_FORM: 'Bezorging',
  SUMMARY: 'Controleren',
};

const initialState = {
  steps: {
    [STEP.LOCATION]: {},
    [STEP.PRODUCT_CARDS]: {},
    [STEP.PRODUCT_CONFIG]: {},
    [STEP.RENTAL_FORM]: {},
    [STEP.DELIVERY_FORM]: {},
    [STEP.SUMMARY]: {},
  },
  pdfBody: {},
  activeStep: STEP.LOCATION,
};

const orderFlowSlice = createSlice({
  name: 'orderFlow',
  initialState,
  reducers: {
    updateStepState: (state, action) => {
      state.steps[action.payload.step] = action.payload.data;
    },
    resetStep: (state, action) => {
      state.steps[action.payload] = initialState.steps[action.payload];
    },
    updateActiveStep: (state, action) => {
      state.activeStep = action.payload;
    },
    clearOrder: (state) => {
      state.steps = initialState.steps;
      state.activeStep = STEP.LOCATION;
    },
    clearPDFBody: (state) => {
      state.pdfBody = {};
    },
    setPdfBody: (state, action) => {
      state.pdfBody = action.payload;
    },
  },
});

export const { 
  updateStepState,
  resetStep,
  updateActiveStep,
  clearOrder,
  clearPDFBody,
  setPdfBody
} = orderFlowSlice.actions;

export default orderFlowSlice.reducer;